import { startCase } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Badge } from 'react-bootstrap';
import useLocalization from '../../hooks/useLocalization';

function isDateString(inputStr) {
  const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;
  return dateRegex.test(inputStr);
}

function getBadgeColorByFieldName(fieldName) {
  const map = {
    status: 'primary',
    type: 'warning'
  };
  return map[fieldName] || 'primary';
}
const getChangeText = (value, change, fieldName) => {
  return (
    <span>
      {change && (
        <span>
          {' '}
          {change}{' '}
          {fieldName === 'status' || fieldName === 'type' ? (
            <Badge style={{ fontSize: 10 }} className={`bg-${getBadgeColorByFieldName(fieldName)}`}>
              {value}
            </Badge>
          ) : (
            <b>
              {isDateString(value)
                ? moment(value).format('MMMM Do YYYY, h:mm a')
                : typeof value !== 'object'
                ? value
                : value?.name || value?.title}
            </b>
          )}
        </span>
      )}
    </span>
  );
};

const LogItem = ({ log }) => {
  const { translate } = useLocalization();
  return (
    <div className="w-100 border p-1 my-1">
      <div style={{ fontSize: 12 }} className="mb-1">
        <b>{log?.['name']}</b> {translate('made_the_following_change_on')}{' '}
        <span className="text-muted font-weight-bold">{moment(log?.['timestamp']).format('MMMM Do YYYY, h:mm a')}</span>
        {log &&
          log.changes.map(l => (
            <div className="mt-1">
              <b>{startCase(l.fieldName)}&nbsp;</b>
              {l.arrayActions ? (
                <div className="mx-3 my-1 rounded bg-light p-1">
                  {l.arrayActions.added?.length > 0 && (
                    <>
                      <h6 className="mb-1 smallFont">
                        <span className="fw-bold">{translate('added')}:</span> {l.arrayActions.added.join(', ')}
                      </h6>
                    </>
                  )}
                  {l.arrayActions.updated?.length > 0 && (
                    <>
                      <h6 className="mb-1 smallFont">
                        <span className="fw-bold">{translate('updated')}:</span>{' '}
                        <div className="ms-2 mt-1 border rounded p-1">
                          {l.arrayActions.updated.map(o => (
                            <h6 className="smallFont mb-0">
                              <span className="fw-bold">{translate('from')}:</span> {o?.oldValue?.toString() || ''}{' '}
                              <span className="fw-bold">{translate('to')}:</span> {o?.newValue?.toString() || ''}
                            </h6>
                          ))}
                        </div>
                      </h6>
                    </>
                  )}
                  {l.arrayActions.removed?.length > 0 && (
                    <>
                      <h6 className="mb-1 smallFont">
                        <span className="fw-bold">{translate('removed')}:</span> {l.arrayActions.removed.join(', ')}
                      </h6>
                    </>
                  )}
                </div>
              ) : (
                <>
                  {l?.fromValue && getChangeText(l?.fromValue, translate('from'), l.fieldName)}
                  {l?.toValue && getChangeText(l?.toValue, translate('to'), l.fieldName)}
                </>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default LogItem;
